import { api, ApiError } from "@/api/api";
import { SubmitAssetsRequestData } from "@/api/submission-types";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export function useSubmitAssets() {
  const queryClient = useQueryClient();

  return useMutation<{}, ApiError, SubmitAssetsRequestData>({
    mutationKey: ["POST", "submission", "submitAssets"],
    mutationFn: api.submission.submitAssets.post,
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ["GET", "episodes"] });
      for (const episodeId of variables.episodeIds) {
        queryClient.invalidateQueries({
          queryKey: ["GET", "episodeDetails", episodeId],
        });
      }
      queryClient.invalidateQueries({
        queryKey: ["GET", "submission", "assetsReadyForSubmission"],
      });
      // TODO: Invalidate only the affected images and masks, not all of them (need to know images and masks ids here, now only episodes ids are given)
      queryClient.invalidateQueries({
        queryKey: ["GET", "images"],
      });
      queryClient.invalidateQueries({
        queryKey: ["GET", "masks"],
      });
    },
  });
}
